import { createSelector } from 'reselect';
import { getWorkOrderManagement } from './getWorkOrderManagement';

export const getWorkOrderOpActionLoading = createSelector(
  [getWorkOrderManagement],
  (workOrderManagement) => {
    return workOrderManagement.workOrderOpActionLoading;
  }
);
